import { BookOpenUserIcon, HeadCircuitIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Flex } from "antd";
import { FatButton } from "components/FatButton/FatButton/";

export function ProjectSettingsFormPreserveDocument<T>(
  props: Readonly<{
    label: string;
    name: string;
    valuePropName: string;
    value: T;
    initialValue?: T;
    onChange: (value: T) => void;
  }>
) {
  const t = useTranslate();
  const handleChange = (value: boolean) => {
    props.onChange(value as T);
  };

  const options = [
    {
      value: false,
      title: t("projects.components.ProjectSettings.abstractiveLabel"),
      content: t("projects.components.ProjectSettings.abstractiveSummary"),
      icon: <HeadCircuitIcon size={32} weight="duotone" />,
    },
    {
      value: true,
      title: t("projects.components.ProjectSettings.extractiveLabel"),
      content: t("projects.components.ProjectSettings.extractiveSummary"),
      icon: <BookOpenUserIcon size={32} weight="duotone" />,
    },
  ];
  return (
    <Flex gap={50} justify="center" style={{ marginTop: 20 }}>
      {options.map((item, index) => {
        return (
          <FatButton
            key={index}
            title={item.title}
            content={item.content}
            icon={item.icon}
            style={{ width: 420, height: 180 }}
            onClick={() => handleChange(item.value)}
            type={props.value === item.value ? "primary" : "default"}
            checked={props.value === item.value}
            titleFontWeight={500}
            contentFontWeight={300}
          />
        );
      })}
    </Flex>
  );
}
